var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"download-btn",attrs:{"href":_vm.url,"download":_vm.fileName,"target":"_blank"}},[_c('icon',{attrs:{"icon":_vm.mdiTrayArrowDown,"size":_vm.IconSize.SM}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }